import React from 'react';
import { Link } from 'react-router-dom';
import CircularProgressBar from "../../components/CircularProgressBar/CircularProgressBar";
import './Cards.styles.scss';

function Card({ link, onClick , ...card }) {
    const CardComponent = link ? Link : 'div';
    const props = {};
    if (link) {
        props.to = link;
    } else if (onClick) {
        props.onClick = onClick;
    }
    return (
        <CardComponent {...props} className="card">
            <div className="card__events">
                <span>{card.formatValue}%</span>
                of eating
                events
            </div>
            <div className="card__img">
                <img src={card.img} alt=""/>
            </div>
            <div className="card__content">
                <div className="card__title">
                    {card.name}
                </div>
                <div className="card__progress">
                    <div className="card__progress-item">
                        <CircularProgressBar
                            value={card.awayHome}
                            size={56}
                            isSmall
                        />
                        <div className="card__progress-text">
                            AFH
                        </div>
                    </div>
                    <div className="card__progress-item">
                        <CircularProgressBar
                            value={card.plannedSpontaneous}
                            size={56}
                            isSmall
                        />
                        <div className="card__progress-text">
                            {card.plannedSpontaneousName}
                        </div>
                    </div>
                </div>
            </div>

        </CardComponent>
    );
}

function Cards({ data }) {
    return (
        <div className="cards">
            {data.map((card, inx) => (
                <div key={card.id} className="cards__item">
                    <Card {...card}/>
                </div>
            ))}
        </div>
    );
}

export default Cards;